var exports = {
  "k": "xf61da738--d5abe9--container",
  "K": "xf61da738--d5abe9--icon",
};

module.exports = exports;
